module.exports = __webpack_public_path__ + "static/media/icon-arrow-down-red.c09dfb65.svg";